import {
  ColDef,
  ICellRendererParams,
  ISetFilterParams,
  ITooltipParams,
} from '@ag-grid-community/core'
import {
  generateMdiIcon,
  HeliosMdiIconClass,
  HeliosMdiIconModifierClass,
} from '../utils/icon-utils'
import { heliosDefaultColWidth, SELECT_ALL } from './default'

export enum IssueStatusName {
  FOUND = 'FOUND',
  IGNORED = 'IGNORED',
  WAITING = 'WAITING',
}

export const statusIconTemplate = (params: ICellRendererParams) => {
  if (params.value === '' || params.value == null) {
    return ''
  } else {
    const status = params.value as IssueStatusName
    const iconClass = getStatusIconClass(status)
    const colorClass = getStatusColorClass(status)

    return generateMdiIcon(iconClass, colorClass ? [colorClass] : [])
  }
}

/**
 * Get icon class of a status.
 */
function getStatusIconClass(status: IssueStatusName): HeliosMdiIconClass {
  switch (status) {
    case IssueStatusName.FOUND:
      return 'mdi-alert-circle'
    case IssueStatusName.WAITING:
      return 'mdi-clock-outline'
    case IssueStatusName.IGNORED:
      return 'mdi-checkbox-marked-circle'
    default:
      return 'mdi-help-circle'
  }
}

/**
 * Get color class of a status.
 */
function getStatusColorClass(
  status: IssueStatusName,
): HeliosMdiIconModifierClass | undefined {
  switch (status) {
    case IssueStatusName.FOUND:
      return 'text-primary'
    case IssueStatusName.WAITING:
      return 'text-muted'
    case IssueStatusName.IGNORED:
      return 'text-muted'
    default:
      return
  }
}

/**
 * Format the casing and naming of the statuses
 */
export function issueStatusNameToDisplayName(status: IssueStatusName) {
  switch (status) {
    case IssueStatusName.FOUND:
      return 'Active'
    case IssueStatusName.WAITING:
      return 'Held'
    case IssueStatusName.IGNORED:
      return 'Accepted'
    default:
      return 'Unknown'
  }
}

/**
 * Get the tooltip to display name of a status
 */
function tooltipValueGetter(params: ITooltipParams) {
  return issueStatusNameToDisplayName(params.value as IssueStatusName)
}

/**
 * Format the break status filter
 */
export function breakStatusFilterCellRender(params: ICellRendererParams) {
  if (params.value === SELECT_ALL) {
    return SELECT_ALL
  }

  const status = params.value as IssueStatusName

  const icon = statusIconTemplate(params)
  const description = issueStatusNameToDisplayName(status)

  return `${icon} ${description}`
}

export const sortStatusFilterValues = (
  a: IssueStatusName,
  b: IssueStatusName,
) => {
  const orderedStatusArray = [
    IssueStatusName.FOUND,
    IssueStatusName.WAITING,
    IssueStatusName.IGNORED,
  ]
  if (a === b) return 0
  return orderedStatusArray.indexOf(a) > orderedStatusArray.indexOf(b) ? 1 : -1
}

export const HsBreakStatusColDef: ColDef = {
  cellStyle: { textAlign: 'center' },
  width: heliosDefaultColWidth.MediumIcon,
  filter: 'agSetColumnFilter',
  cellRenderer: statusIconTemplate,
  tooltipValueGetter: tooltipValueGetter,
  filterParams: {
    defaultToNothingSelected: true,
    closeOnApply: true,
    cellRenderer: breakStatusFilterCellRender,
    values: [
      IssueStatusName.FOUND,
      IssueStatusName.WAITING,
      IssueStatusName.IGNORED,
    ],
    comparator: sortStatusFilterValues,
    buttons: ['apply', 'reset'],
  } as ISetFilterParams,
}
